import Vue from "vue"

export default (to, from, next) => {
  if (to.query.split === "master") {
    Vue.$cookies.set("nf_ab", "master", "1y")
    window.location = window.location.pathname
  } else {
    next()
  }
}
